import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authClient } from '../lib/authClient';
import ResendVerification from '../components/ResendVerification';
import { afterSignInPage } from '../utils/pendingInvite';
import { styles } from './SignIn';

// Where the confirm-your-email link lands. Better Auth has already confirmed the address and
// signed the person in, so this just sends them on: to the invite they opened, or the
// dashboard (which takes a new account to band setup). An expired or used link arrives with ?error=.
export default function EmailVerified() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const linkError = params.get('error');
  const { data: session, isPending, refetch } = authClient.useSession();
  const [email, setEmail] = useState('');

  useEffect(() => { if (!linkError) refetch(); }, [linkError, refetch]);

  useEffect(() => {
    if (!linkError && !isPending && session?.user) navigate(afterSignInPage(), { replace: true });
  }, [linkError, isPending, session?.user, navigate]);

  if (linkError) {
    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <h1 style={styles.title}>This link has expired</h1>
          <p style={styles.text}>
            Confirmation links work for an hour, and only until the email is confirmed.
            Enter your email for a new one, or just sign in and we'll send it.
          </p>
          <div style={styles.form}>
            <input
              type="email"
              autoComplete="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={styles.input}
            />
            {email.includes('@') && <ResendVerification email={email.trim()} label="Send a new link" />}
          </div>
          <p style={styles.footer}>
            <Link to="/sign-in" style={styles.link}>Sign in</Link>
          </p>
        </div>
      </div>
    );
  }

  if (isPending || session?.user) {
    return (
      <div style={styles.page}>
        <div style={styles.card}><p style={styles.text}>Email confirmed. Signing you in…</p></div>
      </div>
    );
  }

  // A link clicked a second time: the email is confirmed, but it doesn't sign in again
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Email confirmed</h1>
        <p style={styles.text}>Your email is confirmed. Sign in to carry on.</p>
        <p style={styles.footer}>
          <Link to="/sign-in" style={styles.link}>Sign in</Link>
        </p>
      </div>
    </div>
  );
}
